module.exports = __webpack_public_path__ + "static/media/img-scope4.716b8f56.png";